// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mKNqY","colMin":"styles_colMin__3H40P"};